import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

import PrimarySmallBlueButton from "../customButtons/PrimarySmallBlueButton";
import ClearIcon from "@mui/icons-material/Clear";
import ErrorButton from "../customButtons/ErrorButton";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

export default function ErrorPopupScreen( { title, open,
  maxWidth, text,
  subText,
  buttonTitle,
  startIcon,
  navigateLink,
  handleClose,
  currentPathname
}) {
 const navigate = useNavigate();
  const handleNavigate = () => {
    handleClose();
    if (navigateLink !== currentPathname) {
      navigate(navigateLink);
    }

  };

  return (
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={maxWidth}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px", // :point_left: custom border radius here
            overflow: "visible", // :bulb: allow icon to overflow
            position: "relative", // :bulb: allow absolute positioning inside
          },
        }}
      >
        <DialogTitle
         
          fontFamily="Inter"
          fontSize="20px"
        >
         
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            style={{
              position: "absolute",
              right: 15,
              top: 2,
            }}
          >
            <CloseIcon sx={{ fontSize: "1.5rem", color: "#555555" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
    <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
        p={2}
      >
        <Grid item xs={12} textAlign="center">
          <IconButton
            sx={{
              width: 81,
              height: 81,
              backgroundColor: "#8A40B51A",
              borderRadius: "50%",
              backdropFilter: "blur(4px)",
              overflow: "visible", // :white_tick: allow image overflow
              position: "relative",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.4)",
              },
            }}
          >
            <Box
              component="img"
              src="/newdashboard/Demo/c5596453699f1f1eb2e15d245698035d719d971e.gif"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)", // :white_tick: keep it centered
                pointerEvents: "none", // :white_tick: so click still works on button
              }}
            />
          </IconButton>
        </Grid>

        <Grid item xs={12} textAlign="center">
          <Typography
            fontSize="24px"
            color="#fd5765"
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",
              lineHeight: "100%",
              fontStyle: "normal",
              letterSpacing: "0%",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {subText && (
          <Grid item xs={12} textAlign="center">
            <Typography
              fontSize="16px"
              color="#3F424C"
              sx={{
                fontWeight: 400,
                fontFamily: "Inter",

                fontStyle: "normal",
                letterSpacing: "0.1px",
              }}
            >
              {subText}
            </Typography>
          </Grid>
        )}

        {/* Cancel Button */}
        <Grid
          item
          xs={12}
          container
          gap={2}
          justifyContent="center"
          alignItems="center"
          mt={2}
          mb={2}
        >
          <ErrorButton
            startIcon={startIcon}
            buttonTitle={buttonTitle}
            onClick={handleNavigate}
            width="100%"
          />
        </Grid>
      </Grid>
      </DialogContent>
      </Dialog>
  )
}
